<template>
  <div class="distribution-input">
    <div class="edit" v-if="!readOnly && internalValue" >
      <!-- {{distrOptions}} -->
      
      <multi-select-component mode="single" v-model="internalDistrValue" 
        :options="distrOptions" 
        :configurationOptions="{'allow-empty': false, 'label-inside':false}"
      >
        <template v-slot:customOption="{props}" >
          <div class="plot-and-name-container">
            <div class="name">{{props.option.value.name}}</div>
            <div class="mini-ecg-container">
              <MiniEcg :data="props.option.value.rows" theme="blue"></MiniEcg>
            </div>
          </div>
        </template>
        <template v-slot:customSingleLabel="{props}" >
          <div class="plot-and-name-container">
            <span class="name">{{props.option.value.name}}</span>
            <div class="mini-ecg-container">
              <MiniEcg
                v-if="props.option.value.rows"
                :data="props.option.value.rows"
                :key="props.option.value.id"
                theme="blue"
              ></MiniEcg>
            </div>
          </div>
        </template>
      </multi-select-component>
      
      <div class="specs">  
        <div class="spec text-input" v-for="spec in internalValue.specifications" :key="spec.name">
          <label>{{spec.name}}</label>
          <text-with-units v-model="spec.value" :unit="spec.unit"/>
        </div>
      </div>
    </div>
    <div v-else-if="internalValue" class="value">
      <!-- <div class="dist-name">{{internalValue.name}}</div> -->
      <div class="specs">
        {{internalValue.name}}{{' ('+internalValue.specifications.map((spec)=>`${spec.name}: ${spec.value}`).join(', ')+')'}}
        <!-- (
        <div class="spec" v-for="spec in internalValue.specifications" :key="spec.name">
          <span>{{spec.name}}: {{spec.value}}&nbsp;</span>
        </div>
        ) -->
      </div> 
    </div>
  </div>
</template>

 

<script>
// name: string
// basicFunction: header + rows + name
// specifications: [{name,value,unit},{name,value,unit}]

import inputMixin from '@/mixins/inputMixin'
import TextWithUnits from '@/components/inputs/TextWithUnits'
import MultiSelectComponent from '@/components/MultiSelectComponent'
import MiniEcg from '@/components/CaseDashboard/MiniEcg'

export default {
  name: 'MultiSelectInput',
  mixins: [inputMixin],
  components: {MultiSelectComponent,MiniEcg,TextWithUnits},
  // data(){
  //   return {
  //     internalDistrValue: null
  //   }
  // },
  computed:{
    distrOptions(){
      return this.valueOptions.map((d)=>{
        // return d
        return {value: {...d.basicFunction,...d},label:d.name,id:d.id}
        // tmp.id = d.basicFunction.name
        // tmp.value = d.basicFunction.name
        // return tmp
      })
    },
    internalDistrValue: {
      get: function () {
        // return this.internalValue
        return this.distrOptions.find((d)=>d.id === this.internalValue.id)
        // let tmp = {...this.internalValue.basicFunction}
        // tmp.id = this.internalValue.basicFunction.name
        // tmp.value = tmp.id
        // return tmp
      },
      set: function (val) {
        this.internalValue = JSON.parse(JSON.stringify(this.valueOptions.find((d)=>d.id === val.id)))
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.distribution-input
  max-width: 350px
  .edit
    .multi-select-component
      min-width: 200px
      .multiselect
        .multiselect__content-wrapper
          overflow: hidden
          .multiselect__content
            overflow-x: hidden
            .after-list-container
              height: 100px
              justify-content: center
              align-items: center
              display: flex
              flex-direction: column
              padding: 10px
              border-top: 1px solid #999999
              .upload
                margin-bottom: 10px
                max-width: 170px
              // .download
  .specs
    display flex
    justify-content flex-end
    .spec
      margin-left 10px
      label
        color: $shuttle-gray
        m-font-size(10, 14)
        text-transform: capitalize

  .plot-and-name-container
    align-items: center
    display: flex
    width: 100%
    .mini-ecg-container
      flex: 1 1 100px
      height: 25px
      position relative
      // .mini-ecg
      //   position absolute
      //   width 100%
      //   height 100%
    .name
      flex: 0 0 180px
      padding-left: 10px
      m-ellipsis(100%)
      
  .read &
    // white-space nowrap
    max-width none
    .dist-name
      white-space nowrap
    .value
      display flex
      .specs
        margin-left 3px
</style>